import { render, staticRenderFns } from "./faceFour.vue?vue&type=template&id=bb89cdc6&"
import script from "./faceFour.vue?vue&type=script&lang=js&"
export * from "./faceFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports